export default {
  getSession({ session }) {
    return session;
  },

  getConsorcio({ consorcio }) {
    return consorcio;
  },

  getFinanciamento({ financiamento }) {
    return financiamento;
  },

  getTrend({ trend }) {
    return trend;
  },

  getFilter({ filter }) {
    return filter;
  },

  getLeads({ leads }) {
    return leads;
  },
  getLeadFromFirestore({ leadff }) {
    return leadff;
  }
};
